module.exports = __webpack_public_path__ + "img/pic5.4de7681f.png";